import GenericCollection from '@/models/GenericCollection'
import GenericModel from '@/models/GenericModel'

export default function(resourceName, data) {
    if (data) {
        let model = new GenericModel(data).setResourceName(resourceName)
        if (data) {
            Object.keys(data).map(key => {
                model.set(key, data[key])
            })
        }

        return model
    }
    return new GenericCollection().setResourceName(resourceName)
}
